/*Package importing*/
import React, { useState } from 'react';

/*Import custom components and assets*/
import H1 from '../../components/heading/h1';
import service from '../../services/service';

const SetPassword = (props) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const sendOTPClick = async () => {
        setLoading(true);
        if (!password && !confirmPassword) {
            setErrorMessage("All fields are mandatory.");
            setLoading(false);
            return false;
        }

        else if (password !== confirmPassword) {
            setErrorMessage("Confirm password does not matches with password");
            setLoading(false);
            return false;
        }
        // call api
        var params = {
            temp_token: props.token,
            password: confirmPassword
        };

        var response = await service(false, "admin/auth/reset-password", params, false, false);
        if (response.status) {
            setLoading(false);
            props.passwordSet(response);
        } else {
            console.log(response);
            setErrorMessage(response.message);
            setLoading(false);
        }
    };

    return (
        <div className="e-auth-widget-wrap">
            <H1 headOne="Set" headTwo="Password." />

            <dd className="e-input-contentbox mb-4">
                <input
                    id="uPass"
                    type="password"
                    value={password}
                    onChange={(event) => { 
                        setPassword(event.target.value);
                        setErrorMessage("");
                    }}
                    required />
                <label htmlFor="uPass">Password</label>
            </dd>
            <dd className="e-input-contentbox mb-5">
                <input
                    id="uCPass"
                    type="password"
                    value={confirmPassword}
                    onChange={(event) => { 
                        setConfirmPassword(event.target.value);
                        setErrorMessage("");
                    }}
                    required
                    onKeyDown={(e) => e.keyCode === 13 && sendOTPClick()} />
                <label htmlFor="uCPass">Confirm Password</label>
            </dd>
            <div className="col-lg-12 e-error-red">
                {
                    errorMessage
                }
            </div>

            <div className={`col-12 p-0 mt-4 ${loading === true ? "e-auth-loader" : ""}`}>
                <span className="e-p-btn e-auth-btn" onClick={sendOTPClick}>
                    <div>Submit</div>
                </span>
            </div>
        </div>
    );
};

export default SetPassword;